import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

// Refund Order
export function* refundOrder() {
  yield takeEvery(actionTypes.MALL_REFUND_ORDER, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallRefundOrder(action.id, action.data);
      if (response.data.success) {
        yield put(actions.mallRefundOrderSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(
          actions.mallLoadOrderList({ status: 2, offset: 0, limit: 10 })
        );
        yield put(actions.mallLoadOrderDetail({ order_id: action.id }));
      } else {
        alert("Warning: Fail to refund order. \n" + response.data.message);
        yield put(actions.mallRefundOrderFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to refund order. \n"));
      yield put(actions.mallRefundOrderFail());
      yield put(actions.disableLoading());
    }
  });
}

// Withdraw Refund
export function* withdrawRefund() {
  yield takeEvery(actionTypes.MALL_WITHDRAW_REFUND, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallWithdrawRefund(action.id);
      if (response.data.success) {
        yield put(actions.mallWithdrawRefundSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(
          actions.mallLoadOrderList({ status: 2, offset: 0, limit: 10 })
        );
        yield put(actions.mallLoadOrderDetail({ order_id: action.orderID }));
      } else {
        alert("Warning: Fail to withdraw refund. \n" + response.data.message);
        yield put(actions.mallWithdrawRefundSuccess());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to withdraw refund. \n"));
      yield put(actions.mallWithdrawRefundSuccess());
      yield put(actions.disableLoading());
    }
  });
}

export default function* mallRefundSaga() {
  yield all([fork(refundOrder), fork(withdrawRefund)]);
}
